export default __webpack_public_path__ + "static/media/longer-planks.f8b8600d.svg";